var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService, { getXSRF } from "./Shared/FetchService";
import PersonDocumentDomainService from "../Domain/PersonDocument/PersonDocument.service";
import SingleResponseService from "../Domain/SingleResponse/SingleResponse.service";
export default class DocumentService {
    static getDocumentsForPerson(affiliationId) {
        return FetchService.get(`/aviso/advisor/getDocuments/${affiliationId}`).then((results) => results.map(PersonDocumentDomainService.fromJSON));
    }
    static deleteDocument(documentId) {
        return FetchService.deleteSingleResponse(`/aviso/advisor/removeDocument`, {
            id: documentId,
        });
    }
    static toggleStudentAccessForDocument(documentId) {
        return FetchService.postSingleResponse(`/aviso/advisor/toggleStudentAccessForDocument`, { id: documentId });
    }
    static uploadDocument(doc, affiliationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("newFilename:", doc.newFileName);
            formData.append("originalFilename", doc.originalFilename);
            formData.append("allowStudentToView:", doc.allowStudentToView.toString());
            formData.append(`${doc.newFileName}|${doc.allowStudentToView ? "true" : "false"}`, doc.file);
            const response = yield fetch(`/aviso/advisor/uploadDocuments/${affiliationId}`, {
                credentials: "include",
                method: "POST",
                headers: {
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: formData,
            });
            const data = yield response.json();
            if (!data.success) {
                throw { response: { data } };
            }
            return SingleResponseService.processSingleResponse(data);
        });
    }
    static uploadToOpportunities(opportunityIds, fileNames, files, externalId, externalName, externalUrl, extension, fileSource, allowStudentsToView) {
        FetchService.postSingleResponse("/aviso/document/uploadToOpportunities", {
            opportunityIds,
            fileNames,
            files,
            externalId,
            externalName,
            externalUrl,
            extension,
            fileSource,
            allowStudentsToView,
        });
    }
}
